export default __webpack_public_path__ + "static/media/maskekeko.f8dad500.gif";